var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-wrapper"},[(_vm.user)?[_c('router-view')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }